import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-pagination',
    templateUrl: './pagination.component.html',
    styles: [],
    standalone: false
})
export class PaginationComponent{
  @Output() event = new EventEmitter<number>();
  @Input() totalPaginas: number = 1;
  @Input() paginaActual: number = 0;
  selectedPage: number;
  isPage: boolean = false;

  selectPage(pageNumber: any, index: number = -1) {
    if (pageNumber === '...') {
      if (index < 4) {
        pageNumber = this.paginaActual - 2;
      } else {
        pageNumber = this.paginaActual + 2;
      }
    }
    this.event.emit(+pageNumber);
  }

  pages() {
    let arr = [];
    if (this.totalPaginas <= 7) {
      for (let i = 0; i < this.totalPaginas; i++) {
        arr.push(i + 1);
      }
    } else {
      arr.push(1);
      if (this.paginaActual <= 4) {
        for (let i = 2; i <= 5; i++) {
          arr.push(i);
        }
        arr.push('...');
      } else if (this.paginaActual > this.totalPaginas - 4) {
        arr.push('...');
        for (let i = this.totalPaginas - 4; i < this.totalPaginas; i++) {
          arr.push(i);
        }
      } else {
        arr.push('...');
        for (let i = this.paginaActual - 1; i <= this.paginaActual + 1; i++) {
          arr.push(i);
        }
        arr.push('...');
      }
      arr.push(this.totalPaginas);
    }
    return arr;
  }

  validatePage() {
    if(this.selectedPage > this.totalPaginas || this.selectedPage <= 0){
      this.isPage = false;
    }else{
      this.isPage = true;
    }
  }
}
